import {
  SET_ACCOUNTS,
  SET_ASSETS,
  SET_EXPENSES,
  SET_NETWORTH,
  SET_YEARS,
  SET_CO_BRAND_TOKEN,
  SET_USER_SESSION_TOKEN,
} from './actionTypes'

export const setAccounts = accounts => {
  return {
    type: SET_ACCOUNTS,
    accounts,
  }
}
export const setAssets = assets => {
  return {
    type: SET_ASSETS,
    assets,
  }
}
export const setExpenses = expenses => {
  return {
    type: SET_EXPENSES,
    expenses,
  }
}
export const setNetWorth = netWorth => {
  return {
    type: SET_NETWORTH,
    netWorth,
  }
}
export const setYears = years => {
  return {
    type: SET_YEARS,
    years,
  }
}
export const setCoBrandToken = cobSessionToken => {
  return {
    type: SET_CO_BRAND_TOKEN,
    cobSessionToken,
  }
}
export const setUserSessionToken = userSessionToken => {
  return {
    type: SET_USER_SESSION_TOKEN,
    userSessionToken,
  }
}



// WEBPACK FOOTER //
// ./api/yodlee/actions.js